/**
 *
 * @param {HTMLInputElement} input
 */
export function hideInputError(input) {
  input.classList.remove('error')
  const sibling = input.nextElementSibling
  if (sibling && sibling.classList.contains('input-error-container')) {
    sibling.innerHTML = ''
  }
}

/**
 * Must have structure below:

  <div class="input-container">
    <input
      data-error-message="Please Enter Your Full Name"
      data-test="name"
      id="name"
      name="name"
      placeholder="Full Name"
      required
      type="text"
    />
    <div class="input-error-container"></div>
  </div>

 */
